import { useContext, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { classes, style } from 'typestyle'
import moment from 'moment'

/* Context ====================================================================================== */
import { NavigationContext } from '../../__aeki__/contexts/navigation'

/* Core ========================================================================================= */
import { addSnippet } from '../../__aeki__/core/snippet-manager'

/* Hooks ======================================================================================== */
import useArray from '../../__aeki__/hooks/use-array'
import useFetch from '../../__aeki__/hooks/use-fetch'
import useValue from '../../__aeki__/hooks/use-value'
import useBoolean from '../../__aeki__/hooks/use-boolean'

/* Components =================================================================================== */
import { Box } from '../../__aeki__/components/box/box.component'
import { Button } from '../../__aeki__/components/button'
import { Form, FormActions, FormContext } from '../../__aeki__/components/form'
import { Line } from '../../__aeki__/components/line'
import { Notification } from '../../__aeki__/components/notification'
import { Snippet, SnippetBody, SnippetHead } from '../../__aeki__/modules/layouts/snippet'
import { Text } from '../../__aeki__/components/text/text.component'
import { Modal } from '../../__aeki__/components/modal'
import '../../modals/time'

/* Styles ======================================================================================= */
import { mt12 } from '../../__aeki__/styles/styleset/margin/mt12'
import { p12 } from '../../__aeki__/styles/styleset/padding/p12'
import { ml12 } from '../../__aeki__/styles/styleset/margin/ml12'
import { ml16 } from '../../__aeki__/styles/styleset/margin/ml16'
import { Circle } from '../../__aeki__/components/circle'
import { pt8i } from '../../__aeki__/styles/styleset/padding/pt8i'
import { pb8i } from '../../__aeki__/styles/styleset/padding/pb8i'
import { mb4 } from '../../__aeki__/styles/styleset/margin/mb4'
import { mb8 } from '../../__aeki__/styles/styleset/margin/mb8'
import { p16 } from '../../__aeki__/styles/styleset/padding/p16'
import { paddingLeftInner } from '../../__aeki__/styles/default/padding'
import { pb8 } from '../../__aeki__/styles/styleset/padding/pb8'
import { pt8 } from '../../__aeki__/styles/styleset/padding/pt8'
import row from '../../__aeki__/default/routes/row'
import { pb12 } from '../../__aeki__/styles/styleset/padding/pb12'
import { pt12 } from '../../__aeki__/styles/styleset/padding/pt12'
import { DAYS, TakeAttendance } from '../childcare-actions'

export default addSnippet('List', (props: any) => {
  const { row, sync } = props

  const { groupId, rowId } = useParams<any>()

  const apiUrl = `${process.env.REACT_APP_API_URL}/a/snippets/classes-children`
  const patchUrl = `${process.env.REACT_APP_API_URL}/a/groups/${groupId}/base/childcare-classes-dailies/table/${rowId}`

  const [data, $data] = useFetch({ data: [], count: 0 }, { url: apiUrl })
  const [patch, $patch] = useFetch({ data: [], count: 0 }, { url: patchUrl })
  const [toggled, $toggled] = useValue(false)
  const [students, $students] = useArray<any>([])
  const [attendance, $attendance] = useValue({})
  const [touched, $touched] = useBoolean(false)

  // useEffect(() => {
  //   if (data.mounted && Object.keys(row).length) {
  //     $data
  //       .get({
  //         url: `${apiUrl}/${row.body.parent.body.program}`,
  //       })
  //       .then((payload: any) => {
  //         $students.set(row.body.students)
  //         $attendance.set(row?.body?.attendance)
  //       })
  //   }
  // }, [data.mounted, row])

  return (
    <>
      <Classes groupId={groupId} program={{ id: rowId }} row={row} />
    </>
  )
})

const Classes = ({
  groupId,
  program,
  row,
}: {
  groupId?: string
  program: any
  day?: any
  refDate?: any
  row?: any
}) => {
  const apiUrl = `${process.env.REACT_APP_API_URL}/a/snippets/childcare-actions/${groupId}/${program.id}`

  const [data, $data] = useFetch({ data: [], count: 0 }, { url: apiUrl })
  const [classList, $classList] = useValue({ data: [] })
  const [enrollment, $enrollment] = useValue({ data: [] })
  const history = useNavigate()

  useEffect(() => {
    if (data.mounted) {
      $data
        .get({
          url: `${apiUrl}`,
        })
        .then((payload: any) => {
          console.log(payload)
          $classList.set(payload.classes)
          $enrollment.set(payload.enrollment)
        })
    }
  }, [data.mounted])

  const refDate = new Date()

  return (
    <>
      {classList.data.map((item: any, key: any) => {
        console.log(item)
        return (
          <Box
            key={key}
            className={classes(mb8)}
            baseline="none"
            rounded
            row
            style={{ width: 'calc(100%)', overflow: 'hidden', userSelect: 'none' }}
            relative
            shadow
          >
            <Box baseline="surface" rounded row>
              <Box baseline="none" row className={classes(p16, pt8i, pb8i)}>
                <Text size="sm" className={mb4} shrink baseline="surface" lighter>
                  Class {key + 1}
                </Text>
                <Text size="md" semiBold>
                  {item.body.title.replace('- undefined', '')}
                </Text>
              </Box>
              <Line />
              {item?.body?.students?.length > 0 ? (
                <>
                  <table
                    style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                    }}
                  >
                    <thead>
                      <td
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          style({ verticalAlign: 'middle' }),
                        )}
                        style={{
                          borderBottom: '1px solid rgb(240,240,240)',
                        }}
                      >
                        <Text size="sm" shrink baseline="surface" lighter>
                          Student Name
                        </Text>
                      </td>
                      <td
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          style({ verticalAlign: 'middle' }),
                        )}
                        style={{
                          borderBottom: '1px solid rgb(240,240,240)',
                        }}
                      >
                        <Text size="sm" shrink baseline="surface" lighter>
                          Primary Guardian
                        </Text>
                      </td>
                      <td
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          style({ verticalAlign: 'middle' }),
                        )}
                        style={{
                          borderBottom: '1px solid rgb(240,240,240)',
                        }}
                      >
                        <Text size="sm" shrink baseline="surface" lighter>
                          Primary Guardian Contact
                        </Text>
                      </td>
                      <td
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          style({ verticalAlign: 'middle' }),
                        )}
                        style={{
                          borderBottom: '1px solid rgb(240,240,240)',
                        }}
                      >
                        <Text size="sm" shrink baseline="surface" lighter>
                          Secondary Guardian
                        </Text>
                      </td>
                      <td
                        className={classes(
                          paddingLeftInner,
                          pt8,
                          pb8,
                          style({ verticalAlign: 'middle' }),
                        )}
                        style={{
                          borderBottom: '1px solid rgb(240,240,240)',
                        }}
                      >
                        <Text size="sm" shrink baseline="surface" lighter>
                          Secondary Guardian Contact
                        </Text>
                      </td>
                    </thead>
                    <tbody>
                      {item.body.students.map((student, key) => {
                        const enrolledStudent = enrollment.data.find(a => a.id === student.id)
                        const { child, primaryGuardian, secondaryGuardian } =
                          enrolledStudent?.body.generalInformation || {}

                        return (
                          <tr key={key}>
                            <td
                              className={classes(
                                paddingLeftInner,
                                pt12,
                                pb12,
                                style({ verticalAlign: 'middle' }),
                              )}
                            >
                              <Box>
                                <Link
                                  to={`/a/groups/${groupId}/base/childcare-clients/table/${enrolledStudent.id}`}
                                >
                                  <Text link>{child.fullName}</Text>
                                </Link>
                              </Box>
                              <Box>
                                <Text size="xs" semiBold shrink>
                                  DOB:{' '}
                                </Text>
                                <Text size="xs" shrink>
                                  {child.dateOfBirth || '-'}
                                </Text>
                              </Box>
                            </td>
                            <td
                              className={classes(
                                paddingLeftInner,
                                pt12,
                                pb12,
                                style({ verticalAlign: 'middle' }),
                              )}
                            >
                              <Box>
                                <Text>
                                  {primaryGuardian.fullName && primaryGuardian.fullName !== ' '
                                    ? primaryGuardian.fullName
                                    : '-'}
                                </Text>
                              </Box>
                            </td>
                            <td
                              className={classes(
                                paddingLeftInner,
                                pt12,
                                pb12,
                                style({ verticalAlign: 'middle' }),
                              )}
                            >
                              <Box>
                                <Text>{primaryGuardian.phone || '-'}</Text>
                              </Box>
                            </td>
                            <td
                              className={classes(
                                paddingLeftInner,
                                pt12,
                                pb12,
                                style({ verticalAlign: 'middle' }),
                              )}
                            >
                              <Box>
                                <Text>
                                  {secondaryGuardian.fullName && secondaryGuardian.fullName !== ' '
                                    ? secondaryGuardian.fullName
                                    : '-'}
                                </Text>
                              </Box>
                            </td>
                            <td
                              className={classes(
                                paddingLeftInner,
                                pt12,
                                pb12,
                                style({ verticalAlign: 'middle' }),
                              )}
                            >
                              <Box>
                                <Text>{secondaryGuardian.phone || '-'}</Text>
                              </Box>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </>
              ) : (
                <Box className={p16}>
                  <Text>No students assigned to this class</Text>
                </Box>
              )}
              <Line />
              <Box className={classes(p16, pt8i, pb8i)} baseline="none" flex style={{ gap: 12 }}>
                {/* <TakeAttendance
                  groupId={groupId}
                  rowId={item.id}
                  index={DAYS.indexOf(day)}
                  refDate={refDate}
                /> */}
                <Button
                  size="md"
                  baseline="secondary"
                  label="View / Edit Class"
                  square
                  onClick={() => {
                    history(`/a/groups/${groupId}/base/childcare-classes/table/${item.id}`)
                  }}
                />
              </Box>
            </Box>
          </Box>
        )
      })}
    </>
  )
}
